import { FC } from "react";

import { Stack } from "@mui/material";

import { BaseStep1Layout, BaseStep1LayoutProps } from "../shared/BaseStep1Layout";

import { useMediaQuery } from "@/common/hooks/useMediaQuery";

export type AuctionStep1LayoutProps = Omit<BaseStep1LayoutProps, "slots"> & {
  additionalDonationPosition: "top-of-page" | "default";
  slots: {
    banner?: React.ReactNode;
    welcomeBackBanner?: React.ReactNode;
    summary: React.ReactNode;
    coreInfo?: React.ReactNode;
    welcomeMessage?: React.ReactNode;
    additionalDonation: React.ReactNode;
    rates: React.ReactNode;
    generateReceipt: React.ReactNode;
    zeffyBusinessModel: React.ReactNode;
    checkoutFooter: React.ReactNode;
    divider?: React.ReactNode;
    mobileChooseTicketsFloatingButton?: React.ReactNode;
  };
};

export const AuctionStep1Layout: FC<AuctionStep1LayoutProps> = ({
  slots,
  additionalDonationPosition = "default",
  isEmbed,
  ...rest
}) => {
  const { isSmallScreen } = useMediaQuery();

  return (
    <BaseStep1Layout
      {...rest}
      isEmbed={isEmbed}
      slots={{
        banner: slots.banner,
        welcomeBackBanner: slots.welcomeBackBanner,
        info: slots.summary,
        order: (
          <Stack width="100%" gap={2}>
            {!isSmallScreen && slots.coreInfo}
            {!isSmallScreen && !isEmbed && slots.divider}
            {slots.welcomeMessage}
            {additionalDonationPosition === "top-of-page" && slots.additionalDonation}
            {slots.rates}
            {additionalDonationPosition === "default" && slots.additionalDonation}
            {isSmallScreen && !isEmbed && slots.divider}
            <Stack width="100%" gap={1}>
              {slots.generateReceipt}
              {slots.zeffyBusinessModel}
            </Stack>
          </Stack>
        ),
        checkoutFooter: slots.checkoutFooter,
        mobileChooseTicketsFloatingButton: slots.mobileChooseTicketsFloatingButton,
      }}
    />
  );
};
